module.exports = __webpack_public_path__ + "static/media/proj2_img5.722c27c9.jpg";